/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IntroduceReferralCodeReceivedInput = {|
  referralCode: string,
  clientMutationId?: ?string,
|};
export type IntroduceReferralCodeReceivedMutationVariables = {|
  input: IntroduceReferralCodeReceivedInput
|};
export type IntroduceReferralCodeReceivedMutationResponse = {|
  +IntroduceReferralCodeReceived: ?{|
    +clientMutationId: ?string
  |}
|};
export type IntroduceReferralCodeReceivedMutation = {|
  variables: IntroduceReferralCodeReceivedMutationVariables,
  response: IntroduceReferralCodeReceivedMutationResponse,
|};
*/


/*
mutation IntroduceReferralCodeReceivedMutation(
  $input: IntroduceReferralCodeReceivedInput!
) {
  IntroduceReferralCodeReceived(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IntroduceReferralCodeReceivedPayload",
    "kind": "LinkedField",
    "name": "IntroduceReferralCodeReceived",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntroduceReferralCodeReceivedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntroduceReferralCodeReceivedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "599094ff6e1513e885b4f3485b4067c2",
    "id": null,
    "metadata": {},
    "name": "IntroduceReferralCodeReceivedMutation",
    "operationKind": "mutation",
    "text": "mutation IntroduceReferralCodeReceivedMutation(\n  $input: IntroduceReferralCodeReceivedInput!\n) {\n  IntroduceReferralCodeReceived(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '33ee687aaa5c64e95f730bb8c348f2ba';

module.exports = node;
